import React from "react"
import useFormField from "../../../../hooks/useFormField"
import FormInputLabel from "../labels/form-field-label"
import ToggleInfo from "../buttons/toggle-info-button"

export default function RangeInput({
  name,
  id,
  min,
  max,
  step,
  label,
  description,
  predefinedValue,
  displayOption,
  globalValue,
  setGlobalValue,
  closeModalLabel,
  moreInfoLabel,
}) {
  const { value, handleChange } = useFormField(
    predefinedValue,
    () => {},
    globalValue,
    setGlobalValue,
    () => {},
  )

  return (
    <div className={`Form__Element FormRange ${displayOption}`} data-f-element-name={name} data-f-type="range">
      <div className="form-labels">
        <FormInputLabel id={id} label={label} />
        <ToggleInfo description={description} id={id} closeModalLabel={closeModalLabel} moreInfoLabel={moreInfoLabel} />
      </div>
      <span>
        <span className="FormRange__Min">{min}</span>
        <input
          type="range"
          name={name}
          id={id}
          min={min}
          max={max}
          step={step}
          value={value || min}
          onChange={(e) => handleChange(e)}
          className="FormRange__Input"
          data-f-datainput=""
          aria-describedby={`${name}_desc`}
        />
        <span className="FormRange__Max">{max}</span>
      </span>
    </div>
  )
}
